// filepath: apps/web/src/features/directory/locations/LocationsRoute.tsx
//
// FR-UI-DIR-1 AC-6 — route shell for /locations.

import { LocationsPage } from "./LocationsPage";

export function LocationsRoute(): React.ReactElement {
  return <LocationsPage />;
}
